import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { Api } from 'src/app/const/api';
import { FieldsType } from 'src/app/enums/fields-type.enum';
import { TableColumn } from 'src/app/interfaces/table-column';
import { HttpService } from 'src/app/services/http/http.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { UpdateOrderPaymentDetailsComponent } from '../update-order-payment-details/update-order-payment-details.component';

@Component({
	selector: 'app-order-details',
	templateUrl: './order-details.component.html',
	styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
	orderId: string;
	orderData: any;
	orderItemsColumns: TableColumn[] = [
		{
			field: 'product_name',
			header: 'Item',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'product_sku',
			header: 'Product SKU',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'variant_name',
			header: 'Product Name',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'quantity',
			header: 'Quantity',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'price',
			currencyField: 'order_currency',
			header: 'Price',
			fieldType: FieldsType.Currency,
			disableSort: false,
			prefix: '$',
			suffix: '',
		},
		{
			field: 'discount_price',
			currencyField: 'order_currency',
			header: 'Discount Price',
			fieldType: FieldsType.Currency,
			disableSort: false,
			prefix: '$',
			suffix: '',
		},
		{
			field: 'weight_gram',
			header: 'Weight(G)',
			fieldType: FieldsType.Number,
			disableSort: false,
			prefix: '',
			suffix: '',
		},
		{
			field: 'weight_oz',
			header: 'Weight(OZ)',
			fieldType: FieldsType.Number,
			disableSort: false,
			prefix: '',
			suffix: '',
		},
		{
			field: 'supplier',
			header: 'Supplier',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'category_name',
			header: 'Category',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
		{
			field: 'brand_name',
			header: 'Brand',
			fieldType: FieldsType.Text,
			disableSort: false,
		},
	];

	orderItems: any[] = [];

	constructor(
		private utilityService: UtilityService,
		private http: HttpService,
		private route: ActivatedRoute,
		private dialogService: DialogService,
	) {
		this.route.params.subscribe((params) => {
			this.orderId = params['orderId'];
		});
	}

	ngOnInit(): void {
		this.getOrderDetails();
	}

	getOrderDetails() {
		this.utilityService.showLoading();
		this.http.get(Api.GET_ORDER_DETAILS(this.orderId)).subscribe({
			next: (res: any) => {
				this.orderData = res;
				this.orderItems = res.order_items;
				this.utilityService.hideLoading();
			},
			error: (err) => {
				console.log(err);
				this.utilityService.hideLoading();
			},
			complete: () => {
				this.utilityService.hideLoading();
			},
		});
	}

	updatePaymentStatus() {
		const ref = this.dialogService.open(UpdateOrderPaymentDetailsComponent, {
			width: '550px',
			header: `Approve Transaction ID fro order #${this.orderData.display_id}`,
			data: {
				orderId: this.orderId,
				userTransactionID: this.orderData.user_transaction_id,
			},
		});

		ref.onClose.subscribe((result) => {
			this.getOrderDetails();
		});
	}
}
